import ClubInvoicePayment from './ClubInvoicePayment.js';
import ClubReverseInvoice from '@legacy/js/dto/ClubReverseInvoice.js';

export default class ClubTransactionInvoice {
    static fromData(data) {
        if (!data) {
            return;
        }
        let clubTransactionInvoice = new ClubTransactionInvoice();
        clubTransactionInvoice.id = data.id;
        clubTransactionInvoice.createdAt = data.createdAt;
        clubTransactionInvoice.canceled = data.canceled;
        clubTransactionInvoice.invoiceId = data.invoiceId;
        clubTransactionInvoice.number = data.number;
        clubTransactionInvoice.invoiceRecipient = data.invoiceRecipient;
        clubTransactionInvoice.amount = data.amount;
        clubTransactionInvoice.dunningAmount = data.dunningAmount;
        clubTransactionInvoice.currency = data.currency;
        clubTransactionInvoice.paymentMethod = data.paymentMethod;
        clubTransactionInvoice.status = data.status;
        clubTransactionInvoice.gross = data.gross;
        clubTransactionInvoice.payments = data.payments.data.map(payment => {
            return ClubInvoicePayment.fromData(payment);
        });
        clubTransactionInvoice.chargeback = data.chargeback;
        clubTransactionInvoice.clubTransactionCount = data.clubTransactionCount;
        clubTransactionInvoice.reverseInvoice = ClubReverseInvoice.fromData(data.reverseInvoice);

        return clubTransactionInvoice;
    }

    static fromInvoice(id, invoice) {
        if (!id || !(invoice instanceof ClubTransactionInvoice)) {
            return;
        }
        let clubTransactionInvoice = new ClubTransactionInvoice();
        clubTransactionInvoice.id = id;
        clubTransactionInvoice.createdAt = invoice.createdAt;
        clubTransactionInvoice.canceled = invoice.canceled;
        clubTransactionInvoice.invoiceId = invoice.id;
        clubTransactionInvoice.number = invoice.number;
        clubTransactionInvoice.invoiceRecipient = invoice.invoiceRecipient;
        clubTransactionInvoice.amount = invoice.amount;
        clubTransactionInvoice.dunningAmount = invoice.dunningAmount;
        clubTransactionInvoice.currency = invoice.currency;
        clubTransactionInvoice.status = invoice.status;
        clubTransactionInvoice.paymentMethod = invoice.paymentMethod;
        clubTransactionInvoice.gross = invoice.gross;
        clubTransactionInvoice.payments = invoice.payments;
        clubTransactionInvoice.chargeback = invoice.chargeback;
        clubTransactionInvoice.reverseInvoice = ClubReverseInvoice.fromData(invoice.reverseInvoice);

        return clubTransactionInvoice;
    }

    getBalance() {
        const invoiceAmount = this.canceled ? 0 : this.gross.data.numerator / this.gross.data.denominator;
        return this.payments.reduce((accumulator, payment) => accumulator - payment.money.numerator / payment.money.denominator, invoiceAmount)
    }

    isPaymentRequired() {
        return this.getBalance() > 0;
    }

    isPayoffRequired() {
        return this.getBalance() < 0;
    }
}
